import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
interface LegalModalProps {
  open: ModalType;
  onClose: () => void;
}
export function LegalModal({
  open,
  onClose
}: LegalModalProps) {
  if (!open) return null;
  const title = open === 'privacy' ? 'Política de Privacidad' : 'Términos de Servicio';
  return <AnimatePresence data-id="element-174">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[2000] flex items-center justify-center p-4" onClick={onClose} data-id="element-175">
          <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} exit={{
        scale: 0.95,
        opacity: 0
      }} className="bg-white rounded-xl max-w-lg w-full max-h-[80vh] flex flex-col shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-176">
            <div className="p-4 border-b border-[#E2E8F0] flex justify-between items-center" data-id="element-177">
              <h3 className="font-bold text-[#1C1C2E]" data-id="element-178">{title}</h3>
              <button onClick={onClose} data-id="element-179">
                <X className="w-5 h-5 text-[#8B8BAA]" data-id="element-180" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-sm text-[#4A4A6A] space-y-4" data-id="element-181">
              <p data-id="element-182">
                Este producto es una guía educativa. No sustituye el consejo
                médico profesional.
              </p>
              <p data-id="element-183">
                Al comprar, aceptas que los resultados pueden variar y dependen
                de la aplicación de la información.
              </p>
              <p data-id="element-184">
                Tu información personal está segura y no será compartida con
                terceros.
              </p>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}